import React, { useState, useEffect, Fragment } from 'react';
import propTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';

const headers = [
  // 'Business Id',
  'Complain Id',
  'Site No',
  'Site Name',
  'FD Ticket Id',
  'Category',
  'Priority',
  // 'Material Req.',
  // 'Raised By',
  'Created On',
  'Last Update',
  'Status',
  'Ticket Tag',
  'CX Category',
  'Channel Partner',
  'Actions',
];

const ViewComplainList = ({ fetchComplainList, complainList,rmTicketFilter,getRmTicketsFilterDropDown }) => {
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);


  useEffect(() => {
    const tableData = [
      'id',
      'site_no',
      'site_name',
      'fd_ticket_id',
      'cat_name',
      'complain_priority',
      'created_at',
      'updated_at',
      'internal_status',
      'ticket_tags',
      'cx_category',
    ];
  
    if (complainList && complainList.resultSets.length > 0) {
      const data = complainList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            channel_partner_status: element.channel_partner_id === 0 ? "No" : "Yes",
            Actions: {
              name: 'View Complain',
              link: `/dashboard/view-complain/${element.id}`,
              item: element,
            },
            
          }
        )
      );
      
      if (data && data.length > 0) {
        setListData(data);
        setPageCount(Math.ceil(complainList.total / complainList.per_page));
        setCurrentPage(complainList.current_page);
      }
    } else {
      setListData([]);
    }
  }, [complainList]);
  

  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("complaintCont") &&
        localStorage.getItem("complaintCont")
    );
    if(installationCont){
      localStorage.setItem("complaintList", JSON.stringify(""));
      localStorage.setItem("complaintCont", 0);
    }
    
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const getcontractFilter = await JSON.parse(
        localStorage.getItem("complaintList") &&
          localStorage.getItem("complaintList")
      );
      if(getcontractFilter){
        await fetchComplainList(getcontractFilter);
      }else{
        await fetchComplainList();
      }
      
      await getRmTicketsFilterDropDown();
      setIsLoading(false);
    })();
  }, [fetchComplainList]);

  

  const applyFilter = async (filterData) => {
    console.log(filterData);
    localStorage.setItem("complaintList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await fetchComplainList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await fetchComplainList(filter,val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };
  const filterToggle = () => {
    setShowFilter(!showFilter);
  };


  return (
    <Layout title={localization.complainList} isLoading={isLoading} Buttons={headerBtns}>
      <TableSection
        data={listData}
        // isId={false}
        headers={headers}
        detailList={complainList}
        pageCount={pageCount}
        srNo={complainList?.from}
        currentPage={currentPage}
        onPageChange={onPageChange}
      />
      
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId=''
        listFilterData={rmTicketFilter?.sites ? rmTicketFilter : null}
        rmTicketFilter
        complaintFilter={true}
        localstorageKey="complaintList"
      />
    </Layout> 
  );
};

ViewComplainList.propTypes = {
  fetchComplainList: propTypes.func,
};

export default ViewComplainList;
